import { DropTarget } from 'react-dnd';
import { ITEM_TYPE, SOURCE_TYPE } from '../constants.js';
import { containerDropTargetSpec, dropTargetCollect } from './dnd.js';

export default DropTarget([SOURCE_TYPE, ITEM_TYPE], containerDropTargetSpec, dropTargetCollect);
